import React, { useState } from "react"
import ConfirmAppointmentCard from "../ConfirmAppointmentCard"
import ConfirmCalendar from "../ConfirmCalendar"

import "./styles.css"

const Confirm = ({ appointment, handleSetView, setSelectedEvent }) => {
  return (
    <>
      <ConfirmAppointmentCard appointment={appointment} />
      <ConfirmCalendar
        appointmentId={appointment.relId}
        appointment={appointment}
        spots={appointment.spots}
        setSelectedEvent={setSelectedEvent}
      />
    </>
  )
}

export default Confirm
